import React from 'react'
import '../../css/breadCrumbBar.css'
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';

export default function BreadCrumbBar({menu, smenu}) {

	const breadcrumbs = (smenu && (smenu !== "")) ? ([
		<Typography key="3" color="text.primary">
			<FormatListBulletedIcon sx={{pr:1, verticalAlign: "-4px"}}/>{menu}
		</Typography>,
		<Typography key="3" color="text.primary">
			{smenu}
		</Typography>,
	]) : ([
		<Typography key="3" color="text.primary">
			<FormatListBulletedIcon sx={{pr:1, verticalAlign: "-4px"}}/>{menu}
		</Typography>,
	]);

 	return (
		<div className="breadCrumbItem">
			<Stack spacing={2}>
				<Breadcrumbs 
					separator={<NavigateNextIcon fontSize="medium" />}
					aria-label="breadcrumb"
					sx={{ 
						".MuiTypography-root" : {
							fontSize: "20px",
							fontWeight: 600,
						},
					}}
				>{breadcrumbs}</Breadcrumbs>
			</Stack>
		</div>
  	)
}
